// extracted by mini-css-extract-plugin
export default {"heading-broder":"Heading_heading-broder__s1ktR","heading-button":"Heading_heading-button__1nryI","heading-content":"Heading_heading-content__8XqJ3"};